const styles = (theme) => ({
    root: {
        padding: '10px 0px',
    },
});

export default styles;
